export const shortName = (str) =>
  str
    .split(" ")
    .map((item) => item[0].toUpperCase())
    .join("");
